export enum VideoOption {
  FirstVideo = 'firstVideo',
  SecondVideo = 'secondVideo',
  BothVideos = 'bothVideos'
}
